
const woosmapPublicKey = "woos-a10037a3-3f08-311e-af1d-2eb8b922749a";
const libraries = "widgets";
const env: string = "prod";

const mapOptions: woosmap.map.MapOptions = {
    center: {lat: 49, lng: 9},
    zoom: 18,
};

const indoorRendererOptions: woosmap.map.IndoorRendererOptions = {
    centerMap: false,
    theme: "sdm_default",
    venue: env === "prod" ? "SDM_2024" : "SDM_2024_dev",
    forceExtrusion: false,
    useInfoWindow: true,
    directionsIcons: {
      destinationIcon: {
        url: "",
        scaledSize: { height: 0, width: 0 },
      },
    },
};
const widgetOptions: woosmap.map.IndoorWidgetOptions = {
    // autocompleteWithDistance: true,
    ui: {
      primaryColor: "rgb(0 0 0 / 80%)",
      secondaryColor: "#e30613",
    },
    autocomplete: {
      maxResponses: 10
    }
  };
const GATag: string = env === "prod" ? "GTM-WJM8VDL2": "GTM-MQ2P2JCK";
export default {
    mapOptions: mapOptions,
    indoorRendererOptions: indoorRendererOptions,
    indoorWidgetOptions: widgetOptions,
    woosmapPublicKey: woosmapPublicKey,
    libraries:libraries,
    query: '',
    GATag: GATag,
    env: env
}
